import React from 'react';

import { ClearancesListPage } from '../../shared/clearances';
import { ORGANIZATION_CLEARANCE_LIST_QUERY_KEY } from './queryKeys';

export const ClearanceList: React.FC = () => {
  return (
    <ClearancesListPage
      title="Clearances"
      queryKeyBase={ORGANIZATION_CLEARANCE_LIST_QUERY_KEY}
      displayTypePrefKey="OrganizationClearance"
      showOrganization={false}
    />
  );
};
